exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "navbar{white-space:nowrap;overflow:hidden;display:flex}navbar news12-button{font-size:0;height:100%}navbar news12-button button{width:100%;height:100%}navbar news12-button button>div{padding-top:0;padding-bottom:0;height:100%}navbar.flex news12-button{flex:1}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./client/app/components/common/navbar/navbar.scss
 ** module id = 144
 ** module chunks = 0
 **/